import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { Button } from "@circle-react-uikit/Button";
import { useAcceptConnectionForUser } from "./useAcceptConnectionForUser";
import { useIgnoreConnectionForUser } from "./useIgnoreConnectionForUser";

interface RespondButtonsProps {
  connectionId?: string;
  memberName?: string;
  memberPublicUid?: string;
}

export const RespondButtons = ({
  memberPublicUid,
  memberName,
  connectionId,
}: RespondButtonsProps) => {
  const { acceptConnectionForUser, isAccepting } = useAcceptConnectionForUser({
    memberPublicUid,
    memberName,
  });

  const { ignoreConnectionForUser, isIgnoring } = useIgnoreConnectionForUser({
    memberPublicUid,
  });

  const handleAcceptConnection = () => {
    if (!connectionId) {
      return;
    }

    acceptConnectionForUser(connectionId);
  };

  const handleIgnoreConnection = () => {
    if (!connectionId) {
      return;
    }

    ignoreConnectionForUser(connectionId);
  };

  return (
    <div className="flex gap-x-2">
      <Button
        variant="secondary"
        onClick={handleIgnoreConnection}
        disabled={isIgnoring || isAccepting}
      >
        {isIgnoring ? (
          <Icon type="loader" viewBox="0 0 16 16" />
        ) : (
          t("profile_drawer.connect_banner.states.ignore")
        )}
      </Button>
      <Button
        variant="primary"
        onClick={handleAcceptConnection}
        disabled={isAccepting || isIgnoring}
      >
        {isAccepting ? (
          <Icon type="loader" viewBox="0 0 16 16" />
        ) : (
          t("profile_drawer.connect_banner.states.accept")
        )}
      </Button>
    </div>
  );
};
